export const tatDescription =
  "TAT (Turnaround Time) is calculated from the time of pickup and it shows an estimated value, not exact.";

export const deliveryZoneEDescription =
  "Pickup and delivery distance is more than 500KM in same state and zone";
